// extracted by mini-css-extract-plugin
export default {"section":"CurrentBid_section__ZjeTT","wrapper":"CurrentBid_wrapper__dnNhC","currentBid":"CurrentBid_currentBid__Kn3Rj","leftCol":"CurrentBid_leftCol__DpUgR"};